import { render, staticRenderFns } from "./ResetModal.vue?vue&type=template&id=8046836a&scoped=true&"
import script from "./ResetModal.js?vue&type=script&lang=js&"
export * from "./ResetModal.js?vue&type=script&lang=js&"
import style0 from "../AuthModal/AuthModal.scss?vue&type=style&index=0&id=8046836a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8046836a",
  null
  
)

export default component.exports